var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_3_User",
    "data-name": "3 User",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.974,
    height: 14.526,
    viewBox: "0 0 19.974 14.526",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_3_Friends",
    "data-name": "3 Friends",
    d: "M4.166,12.057c0-1.977,2.642-2.488,5.775-2.488,3.115,0,5.774.494,5.774,2.47s-2.642,2.487-5.774,2.487C6.825,14.526,4.166,14.032,4.166,12.057Zm13.163.366a4.043,4.043,0,0,0-2.41-3.978.041.041,0,0,1-.026-.042.034.034,0,0,1,.029-.024,14.063,14.063,0,0,1,2.945.258A2.506,2.506,0,0,1,19.8,9.82a1.75,1.75,0,0,1,0,1.517c-.418.906-1.765,1.2-2.289,1.273l-.024,0A.166.166,0,0,1,17.328,12.423Zm-14.866.186c-.523-.075-1.87-.366-2.288-1.273a1.737,1.737,0,0,1,0-1.516A2.5,2.5,0,0,1,2.108,8.636a14.2,14.2,0,0,1,2.945-.257.033.033,0,0,1,.029.023.042.042,0,0,1-.025.043,4.039,4.039,0,0,0-2.411,3.977.165.165,0,0,1-.159.189ZM6.119,3.843a3.822,3.822,0,1,1,7.643,0,3.822,3.822,0,1,1-7.643,0Zm8.918,3.277a3.082,3.082,0,0,1-.439-.042.144.144,0,0,1-.1-.222,5.3,5.3,0,0,0-.077-6,.1.1,0,0,1-.015-.1.118.118,0,0,1,.075-.045,3.184,3.184,0,0,1,.643-.066,3.246,3.246,0,0,1,3.109,4.1,3.186,3.186,0,0,1-3.113,2.381Zm-13.3-2.38A3.246,3.246,0,0,1,4.845.641a3.2,3.2,0,0,1,.644.066.122.122,0,0,1,.074.045.1.1,0,0,1-.015.1,5.3,5.3,0,0,0-.076,6,.145.145,0,0,1-.1.222,2.979,2.979,0,0,1-.439.042H4.849A3.188,3.188,0,0,1,1.736,4.739Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.a2007798925c60d2003bddd8bea4adfc.svg";
export { ForwardRef as ReactComponent };